module.exports = __webpack_public_path__ + "static/media/icon-golfbag.172bab5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-golfbag.svg
// module id = 1002
// module chunks = 0